/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileCarousel_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_itemSearch">;
    readonly " $refType": "ItemTileCarousel_itemSearch";
};
export type ItemTileCarousel_itemSearch$data = ItemTileCarousel_itemSearch;
export type ItemTileCarousel_itemSearch$key = {
    readonly " $data"?: ItemTileCarousel_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileCarousel_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTileBase_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'b55bf5a16e7c51400b77e479c9206bcd';
export default node;
